import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/auth/AuthProvider";

// Gate for broker-only routes. While the on-mount silent refresh is in flight
// we render nothing decisive (a brief status line) so we don't flash the login
// page at an already-signed-in broker. Anonymous users are sent to /login with
// the attempted path remembered, so post-login can return them there.
export function ProtectedRoute() {
  const { status } = useAuth();
  const location = useLocation();

  if (status === "loading") {
    return (
      <p role="status" className="py-16 text-center text-brk-dim">
        Loading…
      </p>
    );
  }

  if (status === "anonymous") {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <Outlet />;
}
